<template>
  <node-view-wrapper class="merge-field-container" contenteditable="false">
    <span>
      <el-popover
        placement="bottom-start"
        trigger="click"
        persistent="false"
        :width="350"
        v-model="visible"
        transition="el-zoom-in-top"
        class="merge-field-popover"
        @show="focusInput"
        popper-class="merge-field-popover"
      >
        <template slot="reference">
          <span class="merge-field" :class="{ warning: !valid, selected: visible }" draggable="true" data-drag-handle>
            <ArrowIcon className="arrow" v-if="valid" height="8" width="8" />
            <img src="@/assets/img/icon-warning.svg" class="warning-icon" v-else style="height: 10px; width: 10px" />
            {{ label }}
          </span>
        </template>
        <template slot="default">
          <div class="bg-white border-brand-sand border-2 rounded-xl relative">
            <div class="bg-brand-light-sand py-2 px-3 text-left rounded-tl-lg rounded-tr-lg border-b-2 border-brand-sand">
              <span class="text-sm leading-6 font-semibold text-gray-900">{{ label }} will be inserted here</span>
            </div>
            <div>
              <div class="flex flex-col">
                <div class="flex flex-row">
                  <div class="flex flex-col shrink border-r-2 border-brand-sand p-3">
                    <label class="text-sm leading-6 text-brand-blue">Fallback Value</label>
                  </div>
                  <div class="flex flex-col grow p-3">
                    <input
                      tabindex="0"
                      v-model="editableFallback"
                      ref="fallbackInput"
                      v-on:keydown.enter="onEnter"
                      v-on:change="updateFallback"
                      class="text-sm leading-6 text-brand-blue outline-none focus:outline-none"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-popover>
    </span>
  </node-view-wrapper>
</template>

<script>
import Vue from 'vue';
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-2';
import ArrowIcon from '@/components/UI/ArrowIcon.vue';

export default Vue.extend({
  components: {
    ArrowIcon,
    NodeViewWrapper,
  },
  props: nodeViewProps,
  data: () => ({
    visible: false, // is popover open?
    editableFallback: '', // temporary value for editing fallback
  }),
  computed: {
    id() {
      return this.node.attrs.id;
    },
    label() {
      return this.node.attrs.label;
    },
    fallback() {
      return this.node.attrs.fallback;
    },
    valid() {
      return !!this.editableFallback;
    },
  },
  mounted() {
    this.editableFallback = this.fallback;
    // The "open" attribute is used to open the popover when the merge field is first inserted:
    if (this.node.attrs.open) {
      this.visible = true;
      this.focusInput();
    }
  },
  methods: {
    // Focus the fallback input box:
    focusInput() {
      this.$nextTick(() => {
        this.$refs.fallbackInput.focus();
      });
    },
    onEnter() {
      this.visible = false; // this allows to close popover by pressing enter on the input box
    },
    updateFallback() {
      this.updateAttributes({
        fallback: this.editableFallback,
      });
    },
  },
});
</script>

<style lang="scss">
.ProseMirror {
  .merge-field-container {
    display: inline; /* fixing popover positioning */
  }
  .merge-field {
    cursor: pointer;
    display: inline-block;
    background: #f8e6ff;
    border: 1px solid #f8e6ff;
    border-radius: 4px;
    padding: 0 5px;
    line-height: 1.5;
    color: #682968;
    font-size: 12px;
    font-weight: 700;
    margin-right: 1px;
    .arrow {
      margin-top: -4px;
      margin-left: 3px;
      margin-right: 3px;
      display: inline-block;
      color: #bb6bd9;
    }
    &.selected {
      border: 1px solid #bb6bd9;
    }
  }

  .merge-field.warning {
    background: #ffe8ac;
    border: 1px solid #ffe8ac;
    color: #2e2308;
    .warning-icon {
      margin-top: -2px;
      margin-left: 0px;
      margin-right: 0px;
      display: inline-block;
      width: 12px;
      height: 12px;
    }
    /* redundant, but just in case! */
    .arrow {
      display: none;
    }
    &.selected {
      border: 1px solid #ffb800;
    }
  }
}
.merge-field-popover.el-popover {
  position: relative; /* fixing popover positioning */
  padding: 0;
  background: transparent;
  border-radius: 0.75rem;
  top: 1.5rem;
  left: 0;
}

/* Remove popper arrow. Ideally do it passing popper options, but does not work! */
.merge-field-popover {
  margin-top: 0 !important;
}
.merge-field-popover .popper__arrow,
.merge-field-popover .popper__arrow::after {
  display: none !important;
}
</style>
